'use client'

import React from 'react'

export function IOSStatusBarBackground() {
  return (
    <div
      className="fixed top-0 left-0 right-0 bg-black z-[100000] hidden [.platform-ios.capacitor-app_&]:block pointer-events-none"
      style={{ height: 'env(safe-area-inset-top)' }}
    />
  )
}
